/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import * as React from 'react';
import DownloadsInformation from './DownloadsInformation';
import DownloadsModelCode from './DownloadsModelCode';
import ClassificationSelection from './ProductClassificationSelection';


interface Props {
    handleSteps: Function
    handleSubmit: Function
    isEdit?: boolean
}
interface State {
    step: number
}
class UploadDownloadsSteps extends React.Component<Props, State> {
    state = {
        step: 1
    };
    next = () => {
        this.setState(prevState => {
            this.props.handleSteps(prevState.step + 1);
            return {
                step: prevState.step + 1
            };
        });
    };

    back = () => {
        this.setState(prevState => {
            this.props.handleSteps(prevState.step - 1);
            return {
                step: prevState.step - 1
            };
        });
    };
    render() {
        const { step } = this.state;
        switch (step) {
            case 1:
                return (
                    <ClassificationSelection {...({ next: this.next, isEdit: this.props.isEdit } as any)} />
                );
            case 2:
                return (
                    <DownloadsModelCode {...({ next: this.next, back: this.back } as any)} />
                );
            case 3:
                return (<DownloadsInformation {...({ back: this.back, handleSubmit: this.props.handleSubmit } as any)} />);

        }
    }
}
export default UploadDownloadsSteps;
